import {
  Chip,
  IconButton,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Form, Formik } from 'formik'
import { head } from 'lodash'
import { Trash2 } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import mockup from '../../assets/mockup_iphone.png'
import iconWhatsApp from '../../assets/whatsapp.svg'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { getBackendURL } from '../../services/config'
import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import ConfirmationModal from '../ConfirmationModal'
import { InputField } from '../InputField'
import QueueMenuTab from '../QueueMenuTab'
import QueueMessagingTab from '../QueueMessagingTab'
import WhatsAppSelectionModal from '../WhatsAppSelectionModal'
import { useStyles } from './styles'

const QueueSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  description: Yup.string().max(255, 'Too Long!'),
  greetingMessage: Yup.string().max(255, 'Too Long!'),
  outOfHoursMessage: Yup.string().max(255, 'Too Long!'),
  complationMessage: Yup.string().max(255, 'Too Long!'),
  transferMessage: Yup.string().max(255, 'Too Long!'),
  ratingMessage: Yup.string().max(255, 'Too Long!')
})

const GREETING_TAGS = [
  {
    name: 'Nome',
    tag: '{{name}}',
    description: 'Nome completo do contato',
    text: 'João'
  },
  {
    name: 'Primeiro Nome',
    tag: '{{firstname}}',
    description: 'Primeiro nome do contato',
    text: 'João da Silva'
  },
  {
    name: 'Hora',
    tag: '{{time}}',
    description: 'Horário atual',
    text: '09:00'
  },
  {
    name: 'Saudação',
    tag: '{{greeting}}',
    description: 'Saudação conforme o horário do dia',
    text: 'Bom dia'
  },
  {
    name: 'Protocolo',
    tag: '{{protocol}}',
    description: 'Protocolo do Atendimento (YYYYMMDD-Atendimento)',
    text: '20230915'
  },
  {
    name: 'Email',
    tag: '{{email}}',
    description: 'Endereço de e-mail do contato',
    text: 'email@email.com'
  },
  {
    name: 'Departamento',
    tag: '{{queue}}',
    description: 'Departamento para o qual o atendimento foi transferido',
    text: 'Suporte'
  },
  {
    name: 'Ticket',
    tag: '{{ticket}}',
    description: 'Número do Atendimento',
    text: '102030'
  },
  {
    name: 'Usuário',
    tag: '{{user}}',
    description: 'Usuário que transferiu o atendimento',
    text: 'Pedro'
  }
]

const QueueModal = ({ open, onClose, queueId, onDeleteSuccess }) => {
  const classes = useStyles()
  const [tab, setTab] = useState('menu')

  const [, setQueues] = useState([])
  const [associatedWhatsappId, setAssociatedWhatsappId] = useState(null)
  const [fullWhatsappData, setFullWhatsappData] = useState(null)

  const initialState = {
    name: '',
    description: '',
    greetingMessage: '',
    outOfHoursMessage: '',
    complationMessage: '',
    transferMessage: '',
    ratingMessage: ''
  }

  const [queue, setQueue] = useState(initialState)
  const [, setSchedulesEnabled] = useState(false)
  const [queueAttachment, setQueueAttachment] = useState(null)
  const queueAttachmentFile = useRef(null)
  const [imagePreviewOpen, setImagePreviewOpen] = useState(false)
  const [, setMediaDeleted] = useState(false)
  const [confirmationOpen, setConfirmationOpen] = useState(false)
  const [newBotName, setNewBotName] = useState('')
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false)
  const [deleteOptionConfirmationOpen, setDeleteOptionConfirmationOpen] =
    useState(false)
  const [optionDeleteConfirmationText, setOptionDeleteConfirmationText] =
    useState('')
  const [optionToDelete, setOptionToDelete] = useState(null)

  const [, setIsGreetingVariablesOpen] = useState(false)
  const [isOutOfHoursOpen, setIsOutOfHoursOpen] = useState(false)
  const [isTransferOpen, setIsTransferOpen] = useState(false)
  const [isCompletionOpen, setIsCompletionOpen] = useState(false)
  const [isRatingOpen, setIsRatingOpen] = useState(false)
  const [, setIsOtherVariablesOpen] = useState(false)

  const [options, setOptions] = useState([])
  const [optionsToDelete, setOptionsToDelete] = useState([])

  const [currentTime, setCurrentTime] = useState([])
  const [schedules, setSchedules] = useState([
    {
      weekday: 'Segunda-feira',
      weekdayEn: 'monday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Terça-feira',
      weekdayEn: 'tuesday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Quarta-feira',
      weekdayEn: 'wednesday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Quinta-feira',
      weekdayEn: 'thursday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Sexta-feira',
      weekdayEn: 'friday',
      startTime: '08:00',
      endTime: '18:00'
    },
    {
      weekday: 'Sábado',
      weekdayEn: 'saturday',
      startTime: '08:00',
      endTime: '12:00'
    },
    {
      weekday: 'Domingo',
      weekdayEn: 'sunday',
      startTime: '00:00',
      endTime: '00:00'
    }
  ])

  const [departmentModalOpen, setDepartmentModalOpen] = useState(false)
  const [selectedOptionForEdit, setSelectedOptionForEdit] = useState(null)

  const [whatsapps, setWhatsapps] = useState([])

  const [whatsappModalOpen, setWhatsappModalOpen] = useState(false)
  const [selectedWhatsappIds, setSelectedWhatsappIds] = useState([])

  useEffect(() => {
    api.get(`/settings`).then(({ data }) => {
      if (Array.isArray(data)) {
        const scheduleType = data.find(d => d.key === 'scheduleType')
        if (scheduleType) {
          setSchedulesEnabled(scheduleType.value === 'queue')
        }
      }
    })

    const loadQueues = async () => {
      try {
        const { data } = await api.get('/queue')
        setQueues(data)

        const { data: whatsappList } = await api.get('/whatsapp')
        const firstWhatsappName =
          whatsappList.length > 0 ? whatsappList[0].name : ''
        // Se for um novo bot, sugere o próximo nome
        if (!queueId) {
          setAssociatedWhatsappId(null)
          setFullWhatsappData(null)
          const botQueues = data.filter(
            q => q.isBot === true || q.isBot === undefined
          )
          const nextBotNumber = botQueues.length + 1
          setNewBotName(`BOT ${nextBotNumber}`)
          setQueue(prev => ({
            ...prev,
            description: firstWhatsappName || ''
          }))
        }
      } catch (err) {
        toastError(err)
      }
    }
    loadQueues()
  }, [queueId])

  useEffect(() => {
    setAssociatedWhatsappId(null)
    setFullWhatsappData(null)
      ; (async () => {
        if (!queueId) return
        try {
          const { data } = await api.get(`/queue/${queueId}`)
          setQueue(prevState => {
            return { ...prevState, ...data }
          })
          setSchedules(data.schedules)
          // Buscando as opções da fila
          const { data: optionsData } = await api.get(`/queue-options`, {
            params: { queueId, parentId: -1 }
          })
          setOptions(optionsData)

          let whatsappName = null
          //add
          const { data: whatsappList } = await api.get('/whatsapp')
          const associatedWhatsapp = whatsappList.find(
            whats =>
              Array.isArray(whats.queues) &&
              whats.queues.some(queue => queue.id === data.id)
          )
          if (associatedWhatsapp) {
            setAssociatedWhatsappId(associatedWhatsapp.id)
            setFullWhatsappData(associatedWhatsapp)
            whatsappName = associatedWhatsapp.name

            setQueue(prevState => ({
              ...prevState,
              complationMessage: associatedWhatsapp.complationMessage || '',
              transferMessage: associatedWhatsapp.transferMessage || '',
              ratingMessage: associatedWhatsapp.ratingMessage || '',
              description: whatsappName
            }))
          } else {
            setAssociatedWhatsappId(null)
            setFullWhatsappData(null)
          }
          setQueueAttachment(null)
          setMediaDeleted(false)
        } catch (err) {
          toastError(err)
        }
      })()

    const updateTime = () => {
      const now = new Date()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      setCurrentTime(`${hours}:${minutes}`)
    }

    updateTime() // Chama a função para definir a hora inicial
    const interval = setInterval(updateTime, 60000)

    return () => {
      setQueue({
        name: '',
        description: '',
        // color: '',
        greetingMessage: ''
      })
      // Resetando os estados das opções
      setOptions([])
      setOptionsToDelete([])
      setQueueAttachment(null)
      setMediaDeleted(false)
      clearInterval(interval)
      setAssociatedWhatsappId(null)
      setFullWhatsappData(null)
    }
  }, [queueId, open])

  useEffect(() => {
    const isAnyOtherOpen =
      isOutOfHoursOpen || isTransferOpen || isCompletionOpen || isRatingOpen
    setIsOtherVariablesOpen(isAnyOtherOpen)
  }, [isOutOfHoursOpen, isTransferOpen, isCompletionOpen, isRatingOpen])

  useEffect(() => {
    const loadWhatsapps = async () => {
      try {
        const { data } = await api.get('/whatsapp')
        setWhatsapps(data)
      } catch (err) {
        toastError(err)
      }
    }
    loadWhatsapps()
  }, [])

  useEffect(() => {
    if (queueId && whatsapps.length > 0) {
      const associatedIds = whatsapps
        .filter(whats => whats.queues?.some(q => q.id === queueId))
        .map(whats => whats.id)
      setSelectedWhatsappIds(associatedIds)
    }
  }, [queueId, whatsapps])

  const handleDeleteQueue = async () => {
    try {
      if (!queueId) return

      await api.delete(`/queue/${queueId}`)
      toast.success(i18n.t('Queue deleted successfully!'))

      // Notifica o componente pai para atualizar a lista
      if (onDeleteSuccess) {
        onDeleteSuccess(queueId)
      }
      setDeleteConfirmationOpen(false)
      handleClose()
    } catch (err) {
      toastError(err)
      setDeleteConfirmationOpen(false)
    }
  }

  const handleRemoveTag = (tagToRemove, values, setFieldValue) => {
    const currentValue = values.greetingMessage || ''
    const regex = new RegExp(
      `\\s*${tagToRemove.replace(/(\{|\})/g, '\\$&')}\\s*`,
      'g'
    )
    const newValue = currentValue.replace(regex, '')

    const cleanedValue = newValue.replace(/\s+/g, ' ').trim()
    setFieldValue('greetingMessage', cleanedValue)
  }

  const renderHighlightedMessage = (message, values, setFieldValue) => {
    if (!message) return null

    const cleanedMessage = message.replace(/&nbsp;/g, ' ')

    const tagMap = GREETING_TAGS.reduce((acc, tag) => {
      acc[tag.tag] = tag
      return acc
    }, {})

    const tags = Object.keys(tagMap)
    if (tags.length === 0) {
      return [cleanedMessage]
    }

    const regex = new RegExp(
      `(${tags.join('|').replace(/(\{|\})/g, '\\$&')})`,
      'g'
    )
    const parts = cleanedMessage.split(regex).filter(part => part.length > 0)
    return parts.map((part, index) => {
      const tagData = tagMap[part]

      if (tagData) {
        return (
          <Chip
            key={index}
            label={tagData.text}
            size="small"
            clickable={false}
            onDelete={() => handleRemoveTag(tagData.tag, values, setFieldValue)}
            className={classes.chipVariableTags}
          />
        )
      } else {
        return <span key={index}>{part}</span>
      }
    })
  }

  const handleClose = () => {
    onClose()
    setQueue(initialState)
    setQueueAttachment(null)
    setMediaDeleted(false)
    setAssociatedWhatsappId(null)
    setFullWhatsappData(null)
    setIsGreetingVariablesOpen(false)
    setIsOutOfHoursOpen(false)
    setIsTransferOpen(false)
    setIsCompletionOpen(false)
    setIsRatingOpen(false)
    setIsOtherVariablesOpen(false)
  }

  const handleQueueAttachmentFile = e => {
    const file = head(e.target.files)
    if (file) {
      setQueueAttachment(file)
      setQueue(prev => ({
        ...prev,
        mediaPath: URL.createObjectURL(file),
        mediaName: file.name
      }))
    }
  }

  const deleteMedia = async () => {
    // Se for um novo anexo ainda não salvo
    if (queueAttachment) {
      setQueueAttachment(null)
      if (queueAttachmentFile.current) {
        queueAttachmentFile.current.value = null
      }
      setQueue(prev => ({ ...prev, mediaPath: null, mediaName: null }))
      setConfirmationOpen(false)
      toast.success('Anexo removido com sucesso!')
      return
    } // Se for um anexo já existente no banco de dados

    if (queue.mediaPath) {
      // Marca para ser deletado ao salvar
      setMediaDeleted(true) // Limpa a visualização/dados localmente

      setQueue(prev => ({ ...prev, mediaPath: null, mediaName: null }))

      toast.success(
        'Anexo marcado para exclusão. Clique em Salvar para confirmar.'
      )
    }
    setConfirmationOpen(false)
  }

  const getMediaUrl = () => {
    if (queueAttachment) {
      return URL.createObjectURL(queueAttachment)
    }
    if (queue?.mediaPath) {
      if (queue.mediaPath.startsWith('http')) {
        return queue.mediaPath
      }
      return `${getBackendURL()}/public/${queue.mediaPath}`
    }
    return null
  }

  const handleSaveQueue = async values => {
    try {
      const finalValues = { ...values, isBot: true }
      let currentQueueId = queueId

      // --- PASSO 1: Persistência do Bot (Fila) ---
      if (queueId) {
        await api.put(`/queue/${queueId}`, { ...finalValues, schedules })
      } else {
        const { data } = await api.post('/queue', { ...finalValues, schedules })
        currentQueueId = data.id
      }

      // Processamento de anexos (mantido do seu original)
      if (queueAttachment != null) {
        const formData = new FormData()
        formData.append('file', queueAttachment)
        await api.post(`/queue/${currentQueueId}/media-upload`, formData)
      }
      await saveQueueOptions(currentQueueId)

      // --- PASSO 2: Sincronização N:N das Conexões ---
      // Esta é a única parte que deve mexer na rota /whatsapp
      const updatePromises = whatsapps.map(async whatsapp => {
        const isSelected = selectedWhatsappIds.includes(whatsapp.id)
        const hasBotAlready = whatsapp.queues?.some(
          q => q.id === currentQueueId
        )

        // Só agimos se houve mudança (Seleção atual vs O que já existe)
        if (isSelected && !hasBotAlready) {
          // ADICIONAR: Pegamos os IDs existentes e injetamos o novo
          const newQueueIds = [
            ...(whatsapp.queues?.map(q => q.id) || []),
            currentQueueId
          ]
          const updateData = {
            ...whatsapp,
            queueIds: newQueueIds,
            // Se for a conexão "principal", atualizamos as mensagens de fluxo também
            ...(whatsapp.id === associatedWhatsappId && {
              outOfHoursMessage: values.outOfHoursMessage,
              complationMessage: values.complationMessage,
              transferMessage: values.transferMessage,
              ratingMessage: values.ratingMessage
            })
          }
          delete updateData['queues']
          delete updateData['session']
          return api.put(`/whatsapp/${whatsapp.id}`, updateData)
        }

        if (!isSelected && hasBotAlready) {
          // REMOVER: Filtramos o ID do bot atual da conexão
          const filteredQueueIds = whatsapp.queues
            .filter(q => q.id !== currentQueueId)
            .map(q => q.id)
          const updateData = { ...whatsapp, queueIds: filteredQueueIds }
          delete updateData['queues']
          delete updateData['session']
          return api.put(`/whatsapp/${whatsapp.id}`, updateData)
        }

        // Caso C: conexão já selecionada e já vinculada ao bot.
        // Sempre sincroniza mensagem de fora do expediente para evitar fallback no padrão.
        if (isSelected && hasBotAlready) {
          const updateData = {
            ...whatsapp,
            queueIds: whatsapp.queues.map(q => q.id),
            outOfHoursMessage: values.outOfHoursMessage,
            ...(whatsapp.id === associatedWhatsappId && {
              complationMessage: values.complationMessage,
              transferMessage: values.transferMessage,
              ratingMessage: values.ratingMessage
            })
          }
          delete updateData['queues']
          delete updateData['session']
          return api.put(`/whatsapp/${whatsapp.id}`, updateData)
        }

        return Promise.resolve()
      })

      await Promise.all(updatePromises)

      const { data: updatedWhatsappList } = await api.get('/whatsapp')
      setWhatsapps(updatedWhatsappList)

      toast.success('Bot e conexões atualizados com sucesso!')
      handleClose()
    } catch (err) {
      toastError(err)
    }
  }

  const saveQueueOptions = async currentQueueId => {
    for (const option of options) {
      const payload = {
        title: option.title,
        option: option.option,
        forwardQueueId: option.forwardQueueId,
        queueId: currentQueueId,
        parentId:
          option.parentId === -1 || option.parentId === undefined
            ? null
            : option.parentId
      }

      if (option.id) {
        console.log(
          `[QueueModal] Enviando PUT para /queue-options/${option.id}`,
          payload
        )
        await api.put(`/queue-options/${option.id}`, payload)
      } else {
        console.log('[QueueModal] Enviando POST para /queue-options', payload)
        await api.post(`/queue-options`, payload)
      }
    }
    for (const option of optionsToDelete) {
      await api.delete(`/queue-options/${option.id}`)
    }
    setOptionsToDelete([])
  }

  const handleAddOption = () => {
    setSelectedOptionForEdit(null) // Garantir que é uma criação
    setDepartmentModalOpen(true)
  }

  const handleDepartmentSave = savedDepartment => {
    setOptions(prevOptions => {
      const existingOptionIndex = prevOptions.findIndex(
        opt => opt.forwardQueueId === savedDepartment.id
      )

      if (existingOptionIndex !== -1) {
        const updatedOptions = [...prevOptions]
        updatedOptions[existingOptionIndex] = {
          ...updatedOptions[existingOptionIndex],
          // id: savedDepartment.id,
          title: savedDepartment.name || savedDepartment.title,
          forwardQueueId: savedDepartment.id
        }
        return updatedOptions
      } else {
        return [
          ...prevOptions,
          {
            id: null, // Ainda não existe o ID da tabela queue-options
            title: savedDepartment.name,
            forwardQueueId: savedDepartment.id, // O ID que acabou de ser gerado/editado no DB
            option: prevOptions.length + 1,
            queueId: queueId,
            parentId: null
          }
        ]
      }
    })

    setDepartmentModalOpen(false)
    setSelectedOptionForEdit(null)
  }

  const handleUpdateOption = (index, updatedOption) => {
    const newOptions = [...options]
    newOptions[index] = updatedOption
    setOptions(newOptions)
  }

  const handleOpenDeleteOption = (index, optionToDelete) => {
    setOptionToDelete({ index, option: optionToDelete })
    setOptionDeleteConfirmationText('')
    setDeleteOptionConfirmationOpen(true)
  }

  const handleCloseDeleteOption = () => {
    setOptionToDelete(null)
    setOptionDeleteConfirmationText('')
    setDeleteOptionConfirmationOpen(false)
  }

  const handleConfirmDeleteOption = async () => {
    if (optionDeleteConfirmationText !== 'EXCLUIR') {
      toast.error(
        'O texto de confirmação está incorreto. Digite EXCLUIR em letras maiúsculas.'
      )
      return
    }

    if (!optionToDelete) {
      handleCloseDeleteOption()
      return
    }

    const { index, option } = optionToDelete

    if (option.id) {
      try {
        await api.delete(`/queue-options/${option.id}`)
      } catch (err) {
        console.error(`Erro ao deletar queue-option ${option.id}:`, err)
        toastError(err)
        return
      }
    }

    if (option.forwardQueueId) {
      try {
        await api.delete(`/queue/${option.forwardQueueId}`)
      } catch (err) {
        console.error(
          `Erro ao deletar queue ${option.forwardQueueId}:`,
          err
        )
        toastError(err)
        return
      }
    }

    const newOptions = options.filter((_, i) => i !== index)
    setOptions(newOptions)
    handleCloseDeleteOption()
  }

  const ImagePreviewModalContent = (
    <Dialog
      maxWidth="xs"
      fullWidth={true}
      open={imagePreviewOpen}
      onClose={() => setImagePreviewOpen(false)}
    >
      <DialogContent className={classes.dialogContentPreview}>
        <img
          src={getMediaUrl()}
          alt="Preview em Tela Cheia"
          className={classes.imagePreview}
        />
      </DialogContent>
      <DialogActions>
        <ButtonSecondary
          onClick={() => setImagePreviewOpen(false)}
          label="Fechar"
        />
      </DialogActions>
    </Dialog>
  )

  const handleTabChange = (event, newValue) => {
    setTab(newValue)
  }

  const handleSaveWhatsAppSelection = selectedIds => {
    setSelectedWhatsappIds(selectedIds)
    setWhatsappModalOpen(false)

    if (selectedIds.length > 0) {
      const firstSelected = whatsapps.find(w => w.id === selectedIds[0])
      setAssociatedWhatsappId(firstSelected.id)
      setFullWhatsappData(firstSelected)
    }
  }

  return (
    <div className={classes.root}>
      <ConfirmationModal
        title={`Excluir Bot: ${queue.name || 'Bot'}`}
        open={deleteConfirmationOpen}
        onClose={() => setDeleteConfirmationOpen(false)}
        onConfirm={handleDeleteQueue}
      >
        Tem certeza de que deseja **excluir permanentemente** o bot **
        {queue.name}**? Todos os dados associados serão perdidos.
      </ConfirmationModal>
      <ConfirmationModal
        title="Deletar Anexo"
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={deleteMedia}
      >
        Tem certeza de que deseja excluir o anexo? Esta ação não pode ser
        desfeita.
      </ConfirmationModal>
      <ConfirmationModal
        title={`Excluir Departamento: ${optionToDelete?.option?.title || ''}`}
        open={deleteOptionConfirmationOpen}
        onClose={handleCloseDeleteOption}
        onConfirm={handleConfirmDeleteOption}
      >
        <div>
          <Typography variant="body1">
            Para confirmar a exclusão do departamento vinculado a esta opção,
            digite "EXCLUIR" no campo abaixo. Caso existam subdepartamentos
            vinculados, eles também serão excluídos:
          </Typography>
          <InputField
            value={optionDeleteConfirmationText}
            onChange={e =>
              setOptionDeleteConfirmationText(e.target.value.toUpperCase())
            }
            label="Confirme a exclusão"
            fullWidth
            autoFocus
          />
        </div>
      </ConfirmationModal>
      <WhatsAppSelectionModal
        open={whatsappModalOpen}
        onClose={() => setWhatsappModalOpen(false)}
        whatsapps={whatsapps}
        selectedIds={selectedWhatsappIds}
        onSave={handleSaveWhatsAppSelection}
      />

      <Dialog
        maxWidth="md"
        fullWidth={true}
        open={open}
        onClose={handleClose}
        scroll="paper"
        PaperProps={{ className: classes.paper }}
      >
        <Formik
          initialValues={
            queueId
              ? queue
              : {
                ...queue,
                name: newBotName
              }
          }
          enableReinitialize={true}
          validationSchema={QueueSchema}
          onSubmit={async (values, actions) => {
            await handleSaveQueue(values)
            actions.setSubmitting(false)
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogTitle className={classes.dialogTitle}>
                <div className={classes.contentDialogTitle}>
                  <div className={classes.contentDialogInfo}>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      className={classes.chipInfo}
                    >
                      {values.name}
                    </Typography>

                    {fullWhatsappData && (
                      <Typography
                        variant="subtitle1"
                        component="span"
                        className={classes.chipInfo}
                      >
                        {fullWhatsappData?.channel === 'whatsapp' ? (
                          <img
                            src={iconWhatsApp}
                            alt="WhatsApp"
                            style={{ width: 18, height: 18 }}
                          />
                        ) : fullWhatsappData?.channel === 'notificamehub' ? (
                          <>
                            <img
                              src={iconWhatsApp}
                              alt="WhatsApp"
                              style={{ width: 18, height: 18 }}
                            />
                            + API
                          </>
                        ) : null}
                      </Typography>
                    )}
                  </div>
                </div>
                <div style={{ display: 'none' }}>
                  <input
                    type="file"
                    ref={queueAttachmentFile}
                    onChange={handleQueueAttachmentFile}
                    accept=".jpg,.jpeg,.png,.bmp,image/jpeg,image/png,image/bmp"
                  />
                </div>
              </DialogTitle>

              <Paper>
                <DialogContent dividers className={classes.dialogContent}>
                  <Tabs
                    value={tab}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    variant="scrollable"
                    onChange={handleTabChange}
                    className={classes.tab}
                  >
                    <Tab
                      label="Menu"
                      value={'menu'}
                      className={classes.tabHeader}
                    />
                    <Tab
                      label="Mensagens"
                      value={'mensagens'}
                      className={classes.tabHeader}
                    />
                  </Tabs>

                  <div className={classes.formWrapper}>
                    {tab === 'menu' && (
                      <QueueMenuTab
                        queueId={queueId}
                        options={options}
                        onAddOption={handleAddOption}
                        onUpdateOption={handleUpdateOption}
                        onDeleteOption={handleOpenDeleteOption}
                        departmentModalOpen={departmentModalOpen}
                        setDepartmentModalOpen={setDepartmentModalOpen}
                        selectedOptionForEdit={selectedOptionForEdit}
                        handleDepartmentSave={handleDepartmentSave}
                      />
                    )}

                    {tab === 'mensagens' && (
                      <QueueMessagingTab
                        values={values}
                        setFieldValue={setFieldValue}
                        queue={queue}
                        queueAttachment={queueAttachment}
                        onAttachClick={() =>
                          queueAttachmentFile.current.click()
                        }
                        onImagePreview={() => setImagePreviewOpen(true)}
                        onDeleteMedia={() => setConfirmationOpen(true)}
                      />
                    )}

                    {/* <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'mensagens'}
                      >
                        <Grid item xs={12} className={classes.contentTab}>
                          <div style={{ display: 'none' }}>
                            <InputField name="name" id="name" />
                            <InputField name="description" id="description" />
                          </div>

                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <InputMessage
                                id="greetingMessage"
                                label={'Mensagem de Saudação'}
                                name="greetingMessage"
                                value={values.greetingMessage}
                                onChange={e =>
                                  setFieldValue(
                                    'greetingMessage',
                                    e.target.value
                                  )
                                }
                                placeholder={
                                  'Olá! 👋 Bem-vindo ao [Nome da Empresa]. Como posso ajudar você hoje?'
                                }
                                onToggleVariables={setIsGreetingVariablesOpen}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <InputMessage
                                label={'Mensagem de Transferência'}
                                name="transferMessage"
                                value={values.transferMessage}
                                onChange={e =>
                                  setFieldValue(
                                    'transferMessage',
                                    e.target.value
                                  )
                                }
                                placeholder={
                                  'Aguarde um momento que seu atendimento foi transferido.'
                                }
                                onToggleVariables={setIsTransferOpen}
                              />
                            </Grid>
                          </Grid>

                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <InputMessage
                                label={'Mensagem Fora do Expediente'}
                                name="outOfHoursMessage"
                                value={values.outOfHoursMessage}
                                onChange={e =>
                                  setFieldValue(
                                    'outOfHoursMessage',
                                    e.target.value
                                  )
                                }
                                placeholder={
                                  'Olá! No momento, estamos fora do horário de atendimento.'
                                }
                                onToggleVariables={setIsOutOfHoursOpen}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <InputMessage
                                label={'Mensagem de Conclusão'}
                                name="complationMessage"
                                value={values.complationMessage}
                                onChange={e =>
                                  setFieldValue(
                                    'complationMessage',
                                    e.target.value
                                  )
                                }
                                placeholder={
                                  'Foi um prazer ajudar você! 😊 Se precisar de mais alguma coisa, estamos à disposição.'
                                }
                                onToggleVariables={setIsCompletionOpen}
                              />
                            </Grid>
                          </Grid>

                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <InputMessage
                                label={'Mensagem de Avaliação'}
                                name="ratingMessage"
                                value={values.ratingMessage}
                                onChange={e =>
                                  setFieldValue('ratingMessage', e.target.value)
                                }
                                placeholder={
                                  'Você poderia nos ajudar avaliando o atendimento? Sua opinião é muito importante para melhorarmos.'
                                }
                                onToggleVariables={setIsRatingOpen}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <div className={classes.activeBox}>
                                <Grid
                                  item
                                  xs={12}
                                  className={classes.attachmentContainer}
                                >
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      gap: '8px',
                                      width: '100%'
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="textSecondary"
                                      style={{
                                        display: 'block',
                                        textAlign: 'center'
                                      }}
                                    >
                                      Formatos: JPG, JPEG, PNG, BMP
                                    </Typography>
                                    <Button
                                      className={classes.buttonsAttachmentFile}
                                      onClick={() => {
                                        if (
                                          queue?.mediaPath ||
                                          queueAttachment
                                        ) {
                                          setImagePreviewOpen(true)
                                        } else {
                                          queueAttachmentFile.current.click()
                                        }
                                      }}
                                    >
                                      {queue?.mediaPath || queueAttachment ? (
                                        <div style={{ textAlign: 'center' }}>
                                          <img
                                            src={getMediaUrl()}
                                            alt="Anexo Preview"
                                            className={
                                              classes.attachmentPreviewImage
                                            }
                                            onError={e => {
                                              e.target.style.display = 'none'
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <Typography
                                          variant="body1"
                                          color="textSecondary"
                                          className={classes.attachmentNotFile}
                                        >
                                          <Paperclip /> Anexar Imagem
                                        </Typography>
                                      )}
                                      {(queueAttachment ||
                                        queue?.mediaPath) && (
                                        <IconButton
                                          onClick={e => {
                                            e.stopPropagation()
                                            setConfirmationOpen(true)
                                          }}
                                          aria-label="delete"
                                          className={classes.iconButtonDelete}
                                          style={{
                                            position: 'absolute',
                                            top: '10px',
                                            right: '10px',
                                            backgroundColor:
                                              theme.palette.white_100.main,
                                            padding: '4px',
                                            zIndex: 10
                                          }}
                                        >
                                          <Trash2 size={16} />
                                        </IconButton>
                                      )}
                                    </Button>
                                  </div>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </TabPanel> */}

                    {/* <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'menu'}
                      >
                        <Grid item xs={12} className={classes.contentTab}>
                          <DepartmentModal
                            open={departmentModalOpen}
                            onClose={() => setDepartmentModalOpen(false)}
                            option={selectedOptionForEdit}
                            onFlowUpdate={() => {}}
                            onSaved={handleDepartmentSave} 
                          />

                          <QueueOptions
                            queueId={queueId}
                            options={options}
                            onAddOption={handleAddOption}
                            onUpdateOption={handleUpdateOption}
                            onDeleteOption={handleDeleteOption}
                            greetingMessage={values.greetingMessage}
                          />
                        </Grid>
                      </TabPanel> */}

                    <div className={classes.view}>
                      {(values.greetingMessage || options.length > 0) && (
                        <div className={classes.viewRealTime}>
                          <div
                            id="viewRealTimeBox"
                            className={classes.viewRealTimeBox}
                          >
                            <span className={classes.viewRealTimeTitle}>
                              {renderHighlightedMessage(
                                values.greetingMessage,
                                values,
                                setFieldValue
                              )}
                            </span>
                            {options.map((option, index) => (
                              <span key={index}>
                                {`${index + 1}. ${option.title}`}
                              </span>
                            ))}
                            <span className={classes.timeStamp}>
                              {currentTime}
                            </span>
                          </div>
                        </div>
                      )}
                      <img
                        src={mockup}
                        alt="mockup"
                        className={classes.mockup}
                      />
                    </div>
                  </div>
                </DialogContent>

                <DialogActions className={classes.dialogActions}>
                  {queueId && (
                    <div className={classes.deleteContainer}>
                      <IconButton
                        onClick={() => setDeleteConfirmationOpen(true)}
                        aria-label="delete-queue"
                        className={classes.buttonDeleteBot}
                      >
                        <Trash2 size={24} />
                      </IconButton>
                    </div>
                  )}

                  <div className={classes.actionsContainer}>
                    <ButtonSecondary
                      onClick={handleClose}
                      disabled={isSubmitting}
                      label={i18n.t('queueModal.buttons.cancel')}
                    />
                    <ButtonPrimary
                      type="submit"
                      disabled={isSubmitting}
                      label={
                        isSubmitting
                          ? 'Salvando...'
                          : queueId
                            ? 'Salvar'
                            : 'Adicionar'
                      }
                    />
                  </div>
                </DialogActions>
              </Paper>
            </Form>
          )}
        </Formik>
      </Dialog>
      {ImagePreviewModalContent}
    </div>
  )
}

export default QueueModal
